// import '../static/rollbar.js'

//import jQuery
import jquery from 'jquery'
import findIndex from 'jspolyfill-array.prototype.findIndex'

import _ from 'lodash'
//$(this.$el).find('.dropdown').dropdown();

//import Semantic UI
import '../semantic/dist/semantic.min.css';
import '../semantic/dist/semantic.min.js';

//import Semantic UI calendar:
//https://github.com/mdehoog/Semantic-UI-Calendar
import '../node_modules/semantic-ui-calendar/dist/calendar.min.css';
import '../node_modules/semantic-ui-calendar/dist/calendar.min.js';

import Vue from 'vue'
//import VueTouch from 'vue-touch';
var VueTouch = require('vue-touch')
Vue.use(VueTouch)

//Sentry error reporting
// import Raven from 'raven-js';
// import RavenVue from 'raven-js/plugins/vue';

// Raven
//     .config('https://0310a13874364d3689fe07c389d4da3d@sentry.io/451827')
//     .addPlugin(RavenVue, Vue)
//     .install();

//import * as Sentry from "@sentry/vue";
//import { Integrations } from "@sentry/tracing";
//
//Sentry.init({
//  Vue,
//  dsn: "https://0095a77e0b5f480bae95e24df957f529@o740400.ingest.sentry.io/5786399",
//  integrations: [new Integrations.BrowserTracing()],
//
//  // Set tracesSampleRate to 1.0 to capture 100%
//  // of transactions for performance monitoring.
//  // We recommend adjusting this value in production
//  tracesSampleRate: 1.0,
//});

import VueRouter from 'vue-router'
//import axios from 'axios'
//import Vuex from 'vuex'
//import VueLazyload from 'vue-lazyload'

import VueMeta from 'vue-meta'

Vue.use(VueRouter)
//Vue.use(Vuex)
//Vue.use(axios) //will not work
//Vue.use(VueLazyload)

Vue.config.debug = false;

//load auto focus 
import autofocus from 'vue-autofocus-directive';
Vue.directive('autofocus', autofocus);

//scroll to 
var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo)
// You can also pass in the default options
Vue.use(VueScrollTo, {
     container: "#container",
     duration: 2000,
     easing: "ease",
     offset: 5,
     force: true,
     cancelable: true,
     onStart: false,
     onDone: false,
     onCancel: false,
     x: false,
     y: true
 });

Vue.use(VueMeta)

//Vue.http.options.root = globalApiUrl;
//Vue.http.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('mw-token');
import store from './store/index';

import App from './App'
import LoadingApp from './components/LoadingApp';

import LoginPage from './components/LoginPage';
import LogoutPage from './components/LogoutPage'

import ResetPasswordPage from './components/ResetPasswordPage'
import RenewPassword from './components/RenewPassword'

import RegisterUserPage from './components/RegisterUserPage'

import AutoshipPage from './components/AutoshipPage'
import AutoshipEditPage from './components/AutoshipEditPage'
import AutoshipAddGoodsPage from './components/AutoshipAddGoodsPage'

import HomePage from './components/HomePage'

import GoodsPage from './components/GoodsPage'
import GoodPage from './components/GoodPage/GoodPage'
import DiscountedGoodsPage from './components/DiscountedGoodsPage'
import NewGoodsPage from './components/NewGoodsPage'
import TopGoodsPage from './components/TopGoodsPage'

import WaitingForDeliveryPage from './components/WaitingForDeliveryPage'
import WaitingForDeliveryViewPage from './components/WaitingForDeliveryViewPage'
import WaitingForDeliveryGetEditPage from './components/WaitingForDeliveryGetEditPage'
import WaitingForDeliveryEditPage from './components/WaitingForDeliveryEditPage'
import WaitingForDeliveryAddGoodsPage from './components/WaitingForDeliveryAddGoodsPage'

import TopUpAccountPage from './components/TopUpAccountPage'
import TopUpAccountProcessPage from './components/TopUpAccountProcessPage'

import UserProfilePage from './components/UserProfilePage'
import UserAddressPage from './components/UserAddressPage'
import UserAddressEditPage from './components/UserAddressEditPage'
import UserAddressAddPage from './components/UserAddressAddPage'
import UserRentedGoodsPage from './components/UserRentedGoodsPage'
import UserInvoicesPage from './components/UserInvoicesPage'
import UserMonthlyBillsPage from './components/UserMonthlyBillsPage'
import UserBillsPage from './components/UserBillsPage'

import CartPage from './components/CartPage'
import CartPaymentPage from './components/CartPaymentPage'
import CartProcessPage from './components/CartProcessPage'
import CartConfirmationPage from './components/CartConfirmationPage'
import CartCancelationPage from './components/CartCancelationPage'
import SuiVue from 'semantic-ui-vue';
import 'semantic-ui-css/semantic.min.css';
import './assets/custom.css';

Vue.use(SuiVue);

const routeExists = (to, from, next) => {
	const existingRoutes = [ // existing routes which are not category names
		'login', 'logout', 'reset-password', 'renew-password', 'new-user',
		'goods', 'good', 'goods-search', 'top-goods', 'discount-goods', 'new-goods',
		'waiting-for-delivery', 'waiting-for-delivery-get-edit-page',
		'autoship', 'topup', 'topup-process', 'user', 'cart', 'loading'
	];
	if (to.params.categorylink == 'login') {
		router.push({
			name: 'login'
		});
	} else if (to.params.categorylink == 'logout') {
		router.push({
			name: 'logout'
		});
	} else if (to.params.categorylink == 'reset-password') {
		router.push({
			name: 'reset-password'
		});
	} else if (to.params.categorylink == 'renew-password') {
		router.push({
			name: 'renew-password'
		});
	} else if (to.params.categorylink == 'new-user') {
		router.push({
			name: 'new-user'
		});
	} else if (to.params.categorylink == 'top-goods') {
		router.push({
			name: 'top-goods'
		});
	} else if (to.params.categorylink == 'discount-goods') {
		router.push({
			name: 'discount-goods'
		});
	} else if (to.params.categorylink == 'new-goods') {
		router.push({
			name: 'new-goods'
		});
	} else if (to.params.categorylink == 'waiting-for-delivery') {
		router.push({
			name: 'waiting-for-delivery'
		});
	} else if (to.params.categorylink == 'autoship') {
		router.push({
			name: 'autoship'
		});
	} else if (to.params.categorylink == 'topup') {
		router.push({
			name: 'topup'
		});
	} else if (to.params.categorylink == 'topup-process') {
		var url = window.location.href;
		var paymentToken = url.substring(url.lastIndexOf('%3D') + 3);
		paymentToken = (paymentToken) ? paymentToken : url.substring(url.lastIndexOf('=') + 1);
		router.push({
			name: 'topup-process', 
			params: {
				token: paymentToken
			}
		});
	} else if (to.params.categorylink == 'user') {
		router.push({
			name: 'user-profile'
		});
	} else if (to.params.categorylink == 'cart') {
		if (to.params.categoryalink && to.params.categoryalink == 'process') {
			var url = window.location.href;
			var paymentToken = url.substring(url.lastIndexOf('%3D') + 3);
			paymentToken = (paymentToken) ? paymentToken : url.substring(url.lastIndexOf('=') + 1);
			router.push({
				name: 'cart-process',
				params: {
					token: paymentToken
				}
			});
		} else {
			router.push({
				name: 'cart'
			});
		}
	} else if (existingRoutes.indexOf(to.params.categorylink) != -1) {
		window.location.replace('/');
	} else {
		next();
	}
}

const routes = [{
        path: '/login',
        name: 'login',
        component: LoginPage
    }, {
        path: '/logout',
        name: 'logout',
        component: LogoutPage
    }, {
        path: '/reset-password',
        name: 'reset-password',
        component: ResetPasswordPage
    }, {
        path: '/renew-password/:token',
        name: 'renew-password',
        component: RenewPassword
    }, {
        path: '/new-user',
        name: 'new-user',
    //    redirect: { name: 'new-user-parent-id', params: { parentid: 0 } }
    //}, {
    //    path: '/new-user/:parentid',
    //    name: 'new-user-parent-id',
        component: RegisterUserPage
    }, {
        path: '/',
        name: 'home',
        component: HomePage
    }, {
        path: '/goods',
        name: 'goods',
        redirect: { name: 'goods-page', params: { page: 1 } }
    }, {
        path: '/good/:id',
        name: 'good',
        component: GoodPage
    }, {
        path: '/goods/:page',
        name: 'goods-page',
        component: GoodsPage
    }, {
        path: '/goods-search/:term',
        name: 'goods-search-page',
        component: GoodsPage
    }, {
        path: '/:categorylink',
        name: 'goods-category-page',
        component: GoodsPage,
		beforeEnter: routeExists
    }, {
        path: '/:categorylink/:categoryalink',
        name: 'goods-categorya-page',
        component: GoodsPage,
		beforeEnter: routeExists
    }, {
        path: '/:categorylink/:categoryalink/:categoryblink',
        name: 'goods-categoryb-page',
        component: GoodsPage,
		beforeEnter: routeExists
    }, {
        path: '/:categorylink/:page',
        name: 'goods-category-page-n',
        component: GoodsPage,
		beforeEnter: routeExists
    }, {
        path: '/:categorylink/:categoryalink/:page',
        name: 'goods-categorya-page-n',
        component: GoodsPage,
		beforeEnter: routeExists
    }, {
        path: '/:categorylink/:categoryalink/:categoryblink/:page',
        name: 'goods-categoryb-page-n',
        component: GoodsPage,
		beforeEnter: routeExists
    }, {
        path: '/top-goods',
        name: 'top-goods',
        component: TopGoodsPage
    }, {
        path: '/discount-goods',
        name: 'discount-goods',
        component: DiscountedGoodsPage
    }, {
        path: '/new-goods',
        name: 'new-goods',
        component: NewGoodsPage
    }, {
        path: '/waiting-for-delivery',
        name: 'waiting-for-delivery',
        component: WaitingForDeliveryPage,
        meta: { requiresAuth: true }
    }, {
        path: '/waiting-for-delivery/:id/view',
        name: 'waiting-for-delivery-view', //in addition can pass ?approve=yes for auto approve
        component: WaitingForDeliveryViewPage,
        meta: { requiresAuth: true }
    }, {
        path: '/waiting-for-delivery/:id/edit',
        name: 'waiting-for-delivery-edit',
        component: WaitingForDeliveryEditPage,
        meta: { requiresAuth: true }
    }, {
        path: '/waiting-for-delivery-get-edit-page/:id',
        name: 'waiting-for-delivery-get-edit-page',
        component: WaitingForDeliveryGetEditPage,
        meta: { requiresAuth: true }
    }, {
        path: '/waiting-for-delivery/:id/addgoods/:page',
        name: 'waiting-for-delivery-addgoods',
        component: WaitingForDeliveryAddGoodsPage,
        meta: { requiresAuth: true }
    }, {
        path: '/autoship',
        name: 'autoship',
        component: AutoshipPage,
        meta: { requiresAuth: true }
    }, {
        path: '/autoship/:id',
        name: 'autoship-edit',
        component: AutoshipEditPage,
        meta: { requiresAuth: true }
    }, {
        path: '/autoship/:id/addgoods/:page',
        name: 'autoship-add-goods',
        component: AutoshipAddGoodsPage,
        meta: { requiresAuth: true }
    }, {
        path: '/topup',
        name: 'topup',
        component: TopUpAccountPage,
        meta: { requiresAuth: true }
    }, {
        path: '/topup/:payment_id',
        name: 'topup-payment',
        component: TopUpAccountPage,
        meta: { requiresAuth: true }
    }, {
        path: '/topup-process/:token',
        name: 'topup-process',
        component: TopUpAccountProcessPage,
        meta: { requiresAuth: true }
    }, {
        path: '/user/profile',
        name: 'user-profile',
        component: UserProfilePage,
        meta: { requiresAuth: true }
    }, {
        path: '/user/profile/chage-password',
        name: 'user-profile-change-password',
        component: UserProfilePage,
        meta: { requiresAuth: true }
    }, {
        path: '/user/address',
        name: 'user-address',
        component: UserAddressPage,
        meta: { requiresAuth: true }
    }, {
        path: '/user/address/:id/edit',
        name: 'user-address-edit',
        component: UserAddressEditPage,
        meta: { requiresAuth: true }
    }, {
        path: '/user/address/add',
        name: 'user-address-add',
        component: UserAddressAddPage,
        meta: { requiresAuth: true }
    }, {
        path: '/user/rented-goods/:page',
        name: 'user-rented-goods-page',
        component: UserRentedGoodsPage,
        meta: { requiresAuth: true }
    }, {
        path: '/user/rented-goods',
        name: 'user-rented-goods',
        redirect: { name: 'user-rented-goods-page', params: { page: 1 } },
        meta: { requiresAuth: true }
    }, {
        path: '/user/invoices',
        name: 'user-invoices',
        redirect: { name: 'user-invoices-page', params: { page: 1 } },
        meta: { requiresAuth: true }
    }, {
        path: '/user/invoices/:page',
        name: 'user-invoices-page',
        component: UserInvoicesPage,
        meta: { requiresAuth: true }
    }, {
        path: '/user/monthly-bills',
        name: 'user-monthly-bills',
        redirect: { name: 'user-monthly-bills-page', params: { page: 1 } },
        meta: { requiresAuth: true }
    }, {
        path: '/user/monthly-bills/:page',
        name: 'user-monthly-bills-page',
        component: UserMonthlyBillsPage,
        meta: { requiresAuth: true }
    }, {
        path: '/user/bills',
        name: 'user-bills',
        redirect: { name: 'user-bills-page', params: { page: 1 } },
        meta: { requiresAuth: true }
    }, {
        path: '/user/bills/:page',
        name: 'user-bills-page',
        component: UserBillsPage,
        meta: { requiresAuth: true }
    }, {
        path: '/cart',
        name: 'cart',
        component: CartPage,
        meta: { requiresAuth: true }
    }, {
        path: '/cart/payment',
        name: 'cart-payment',
        component: CartPaymentPage,
        meta: { requiresAuth: true }
    }, {
        path: '/cart/process/:token',
        name: 'cart-process',
        component: CartProcessPage,
        meta: { requiresAuth: true }
    }, {
        path: '/cart/confirmation',
        name: 'cart-confirmation',
        component: CartConfirmationPage,
        meta: { requiresAuth: true }
    }, {
        path: '/cart/confirmation/:orderid',
        name: 'cart-confirmation-orderid',
        component: CartConfirmationPage,
        meta: { requiresAuth: true }
    }, {
        path: '/cart/canceled',
        name: 'cart-canceled',
        component: CartCancelationPage,
        meta: { requiresAuth: true }
    }, {
        path: '/loading',
        name: 'loading',
        component: LoadingApp
    },
    { path: '*', redirect: '/' } //404
]

//setup user context
// Raven.setUserContext({
//     id: store.state.userStore.user.id
// });

// Init router
const router = new VueRouter({
    mode: "history",
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (savedPosition) resolve(savedPosition)
                else resolve({ x: 0, y: 0 })
            }, 500)
        })
    }
})

router.beforeEach((to, from, next) => {
    //routes that does not requre user tokken
    if (to.name == 'reset-password' || to.name == 'renew-password' || to.name == 'loading' || to.name == 'login') {
        next();
    }
    //go to loading page and preload app
    else if ((!store.state.userStore.status.loaded || !store.state.categoryStore.status.loaded) && to.name != 'loading') {
        next({
            name: 'loading',
            query: {
                to: to.fullPath
            }
        });
    }
    //if user tries to login
    else if (store.state.userStore.token == '' && to.name != 'login') {
        next({
            name: 'login',
        });
    }
    //if auth required then check if user is auth
    else if (to.matched.some(record => record.meta.requiresAuth)) {
        //if role is ok then proceed
        if (store.state.userStore.user.role > 0) {
            next();
        }
        //if role is not ok, but he tries to go to cart page then ask to either login or register then go to login page
        else if (store.state.userStore.user.role == 0 && to.name == 'cart') {
            next({
                name: 'login',
            });
        }
        //if user is not authorised/guest and tries to access auth route than ask him to login
        else {
            next({
                name: 'login',
            });
        }
    }
    //else go to page
    else {
        next();
    }

});

router.afterEach((to, from, next) => {
    //window.scrollTo(0, 0); //for some reason native scroll behavior does not work
})

//init app
const app = new Vue({
    router,
    store,
    components: {
        'app': App,
    }
}).$mount('#app');


// WEBPACK FOOTER //
// ./src/main.js